// @flow
import _ from 'lodash';
import moment from 'moment';

import ApiManager from './ApiManager';

import APIEndpoints from '../constants/APIEndpoints';

// entities.
import RestaurantDashboardInfo from '../entities/dashboard/RestaurantDashboardInfo';
import ApiError from '../entities/ApiError';

class ApiDashboard {


  /**
  *
  *
  */
  static getRestaurantDashboard(restaurantId: string, success: Function, failure: Function) {
    const endpoint = APIEndpoints.DASHBOARD_INFO_RESTAURANT.replace('{restaurantId}', restaurantId);

    const requestOptions = {
      endpoint,
      query: {},
      success: (json: Object) => {
        console.log('[BOOKINGS_FOR_DATE] SUCCESS: ', json);

        const restaurantDashboardInfo: RestaurantDashboardInfo = new RestaurantDashboardInfo();
        restaurantDashboardInfo.fromJson(json);

        success(restaurantDashboardInfo);
      },
      failure: (apiError: ApiError) => {
        console.log('[BOOKINGS_FOR_DATE] FAILURE: ', apiError);
        failure(apiError);
      }
    }

    ApiManager.get(requestOptions);
  }

}

export default ApiDashboard;



// WEBPACK FOOTER //
// ./sdk/scripts/api/ApiDashboard.js